export { useModal as getModalById, type Modal } from './model'

export * from './ui'
export * from './config'
